module.exports = __webpack_public_path__ + "static/img/err.a212336.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/err.png
// module id = +G9U
// module chunks = 1